// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1LumC","label":"LabeledBox_label__2e0Bb"};